import { useCustom, useCustomMutation } from '@refinedev/core';
import { AuthMethod } from 'src/auth/settings/types';

export type TenantConfig = {
  id: string;
  companyId: string;
  authMethod: AuthMethod;
};

export const useTenantConfig = (companyId: string) => {
  const { data, isLoading, isError, error, refetch } = useCustom<TenantConfig>({
    url: `admin/companies/${companyId}/config`,
    method: 'get',
    queryOptions: {
      enabled: !!companyId,
    },
  });

  return {
    config: data?.data,
    isLoading,
    isError,
    error,
    refetch,
  };
};

type UpdateTenantConfigInput = {
  authMethod: AuthMethod;
};

export const useUpdateTenantConfig = (companyId: string) => {
  const { mutateAsync, isLoading, error } = useCustomMutation<TenantConfig>();

  const updateConfig = async (input: UpdateTenantConfigInput) => {
    return mutateAsync({
      url: `admin/companies/${companyId}/config`,
      method: 'put',
      values: input,
    });
  };

  return {
    updateConfig,
    isLoading,
    error,
  };
};
